import { useEffect } from 'react';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { EsriMapEntityTypeEnum } from '../../esri/types';
import { usePhoneCallsStore } from '../../phone-calls/use-phone-calls';
import { useEsriMapStore } from './use-esri-map-store';
import { usePhoneNumberIdsForEvent } from './use-phone-number-ids-for-event';

export function useSyncPhoneCallsForSelectedEventInFr() {
    const { isFirstResponder } = useApplicationType();
    const mapStore = useEsriMapStore();
    const phoneCallsStore = usePhoneCallsStore();
    const getPhoneNumberIds = usePhoneNumberIdsForEvent();

    useEffect(
        function syncPhoneCallsForSelectedEvent() {
            if (
                !isFirstResponder ||
                !mapStore.selectedEventId ||
                mapStore.selectedMapLedgerEntityType !== EsriMapEntityTypeEnum.EVENT
            ) {
                return;
            }

            const phoneNumberIds = getPhoneNumberIds(mapStore.selectedEventId);
            if (!phoneNumberIds.length) {
                return;
            }

            mapStore.setRelatedAmlRapidSOSCallsEntities({
                phoneNumberIds,
                amlCallsList: phoneCallsStore.amlCallsList,
                activePhoneCallsList: phoneCallsStore.activePhoneCallsList,
            });
            mapStore.refreshPolylines(EsriMapEntityTypeEnum.EVENT);
        },
        [
            isFirstResponder,
            mapStore,
            mapStore.selectedEventId,
            mapStore.selectedMapLedgerEntityType,
            phoneCallsStore.activePhoneCallsList,
            phoneCallsStore.amlCallsList,
            getPhoneNumberIds,
        ]
    );
}
